Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.ClipboardFormats = module.exports.default = {
	FAST: "fast",
	FULL: "full"
};